import React from 'react';
import { Card } from './card';

export const LoadingSkeleton = () => {
  return (
    <section className="bg-[#FFF] w-[1280px] pt-16 px-24 pb-40 mx-auto my-16">
      <div className="h-[14px] bg-[#e7e7e7] w-[160px] mb-8" />
      <div className="h-[14px] bg-[#e7e7e7] w-[80px] mb-24" />
      <div className="h-[14px] bg-[#e7e7e7] w-[160px] mb-8" />
      <div className="grid grid-cols-2 gap-24">
        <Card height={234} />
        <Card height={234} />
      </div>
      <div className="h-[14px] bg-[#e7e7e7] w-[160px] mb-24 mt-40" />
      <div className="grid grid-cols-4 gap-24">
        <Card height={112} />
        <Card height={112} />
        <Card height={112} />
        <Card height={112} />
      </div>
    </section>
  );
};
